import { Service } from '@roc/feature-app-core';

const url = {
  LOAN_APPRAISALS: '/api/v1/roc-valuation/dashboards/getValuationDashboard',
  STANDALONE_APPRAISALS: '/api/v1/loan/appraisal/getStandaloneAppraisals',
  ADD_APPRAISAL_DOCUMENT: '/api/v1/loan/appraisal/addAppraisalDocument',
  ADD_STANDALONE_VALUATION_DOCUMENT: '/api/v1/roc-valuation/addValuationDocument',
  VALID_FROM_TO_LOANS_OPTIONS: '/nportal/rest/priv/valueLink/getValidLoansMoveFromAppraisal',
  CREATE_TAMARISK_TASK_TO_MOVE_APPRAISAL: '/nportal/rest/priv/valueLink/createTamariskTaskToMoveLoan',
  GET_PROPERTIES_OPTIONS: '/nportal/rest/priv/valueLink/getPropertiesOptionsByLoanId',
  GET_APPRAISAL_REPORT: '/api/v1/loan/appraisal/getAppraisalReport',
  REQUEST_APPRAISAL_RECONSIDERATION: '/nportal/rest/priv/valueLink/requestAppraisalReconsideration',
};

export class AppraisalsService extends Service {
  getLoanAppraisals(
    valuationTab: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object,
    isBackOfficeView: Boolean
  ) {
    return this.get(
      url.LOAN_APPRAISALS,
      {
        valuationTab,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
        isBackOfficeView
      },
      {
        disableGlobalLoading: true,
      }
    );
  }
  getStandaloneAppraisals(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.STANDALONE_APPRAISALS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters,
      },
      {
        disableGlobalLoading: true,
      }
    );
  }
  addAppraisalDocument(
    propertyAppraisalId: number,
    isLoanAppraisal: boolean,
    documentType: string,
    file: File
  ) {
    const formData = new FormData();
    formData.append('propertyAppraisalId', propertyAppraisalId.toString());
    formData.append('isLoanAppraisal', isLoanAppraisal.toString());
    formData.append('documentType', documentType);
    formData.append('file', file);
    return this.post(url.ADD_APPRAISAL_DOCUMENT, formData);
  }

  addValuationDocument(
    loanPropertyValuationId: number,
    isLoanAppraisal: boolean,
    documentType: string,
    file: File
  ) {
    const formData = new FormData();
    formData.append('loanPropertyValuationId', loanPropertyValuationId.toString());
    formData.append('documentType', documentType);
    formData.append('file', file);
    formData.append('isLoanAppraisal', isLoanAppraisal.toString());
    return this.post(url.ADD_STANDALONE_VALUATION_DOCUMENT, formData);
  }

  getValidLoanFromMoveAppraisal(loanId) {
    return this.get(`${url.VALID_FROM_TO_LOANS_OPTIONS}?loanId=${loanId}`);
  }

  createTamariskTaskToMoveLoan(fromLoanId, toLoanId, fromPropertyId) {
    return this.post(`${url.CREATE_TAMARISK_TASK_TO_MOVE_APPRAISAL}?fromLoanId=${fromLoanId}&toLoanId=${toLoanId}&fromPropertyId=${fromPropertyId}`, null)
  }

  getPropertiesOptions(loanId) {
    return this.get(`${url.GET_PROPERTIES_OPTIONS}?loanId=${loanId}`)
  }

  getAppraisalReport(propertyId, loanId, propertyAppraisalId) {
    let query = `propertyId=${propertyId}&propertyAppraisalId=${propertyAppraisalId}`;
    if (loanId != null) {
      query += `&loanId=${loanId}`;
    }

    return this.get(`${url.GET_APPRAISAL_REPORT}?${query}`);
  }
  requestReconsideration(loanId, propertyId) {
    return this.post(`${url.REQUEST_APPRAISAL_RECONSIDERATION}?loanId=${loanId}&propertyId=${propertyId}`, null);
  }
}
